import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-68.jpg'
import _imports_1 from '@/assets/images/screenshorts.jpg'
import _imports_2 from '@/assets/images/carousel-1.jpg'


const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6 overflow-hidden" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Avatar Size Rounded-Circle Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center gap-4 flex-wrap" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "wh-87 rounded-circle",
                  alt: "user"
                }),
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "wh-77 rounded-circle",
                  alt: "user"
                }),
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "wh-67 rounded-circle",
                  alt: "user"
                }),
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "wh-57 rounded-circle",
                  alt: "user"
                }),
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "wh-47 rounded-circle",
                  alt: "user"
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<img src=\"@/assets/images/user-68.jpg\" class=\"wh-87 rounded-circle\" alt=\"user\">\n<img src=\"@/assets/images/user-68.jpg\" class=\"wh-77 rounded-circle\" alt=\"user\">\n<img src=\"@/assets/images/user-68.jpg\" class=\"wh-67 rounded-circle\" alt=\"user\">\n<img src=\"@/assets/images/user-68.jpg\" class=\"wh-57 rounded-circle\" alt=\"user\">\n<img src=\"@/assets/images/user-68.jpg\" class=\"wh-47 rounded-circle\" alt=\"user\">\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6 overflow-hidden" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Avatar Size Simple Rounded Example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center gap-4 flex-wrap" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-87 rounded-3",
                  alt: "screenshorts"
                }),
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-77 rounded-3",
                  alt: "screenshorts"
                }),
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-67 rounded-3",
                  alt: "screenshorts"
                }),
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-57 rounded-3",
                  alt: "screenshorts"
                }),
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-47 rounded-3",
                  alt: "screenshorts"
                })
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"wh-87 rounded-3\" alt=\"screenshorts\">\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"wh-77 rounded-3\" alt=\"screenshorts\">\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"wh-67 rounded-3\" alt=\"screenshorts\">\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"wh-57 rounded-3\" alt=\"screenshorts\">\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"wh-47 rounded-3\" alt=\"screenshorts\">\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4 pb-0" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Avatar size rounded-circle example"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-lg-6 mb-4" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "border border-3",
                    alt: "screenshorts"
                  })
                ]),
                _createElementVNode("div", { class: "col-lg-6 mb-4" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "rounded-circle border border-3",
                    alt: "screenshorts"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"row\">\n<div class=\"col-lg-6 mb-4\">\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"border border-3\" alt=\"screenshorts\">\n</div>\n<div class=\"col-lg-6 mb-4\">\n<img src=\"@/assets/images/screenshorts.jpg\" class=\"border rounded-circle border-3\" alt=\"screenshorts\">\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Responsive Images"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("img", {
                src: _imports_2,
                class: "border-3 border-color-white",
                alt: "carousel"
              })
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<img src=\"@/assets/images/carousel-1.jpg\" class=\"border-3 border-color-white\" alt=\"carousel\">\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}